/**
 * Created by joellee on 11/10/15.
 */

dealershipModule.controller('SettingsSummaryController',
    ['$scope', 'dealerPreferencesService', 'dealerPackService', 'profitSettingsService', 'dealerProfileService', 'ProfitSetting', 'DealerPack', 'authorizationService', 'additionalSecuritySections',
        'DealerPreferences', 'settingsCacheService', 'productSettingsDialogConstants', 'dealershipModuleConstants', 
        '$mdDialog', '$q','TLCError','AppErrorCodes',
    function ($scope, dealerPreferencesService, dealerPackService, profitSettingsService, dealerProfileService, ProfitSetting, DealerPack, authorizationService, additionalSecuritySections,
              DealerPreferences, settingsCacheService, productSettingsDialogConstants, dealershipModuleConstants, 
              $mdDialog, $q, TLCError,AppErrorCodes) {

            $scope.productSettingsDisplayList = [];
            $scope.views = angular.copy(productSettingsDialogConstants);
            $scope.loading = false;

            var _productSettingsDisplayDictionary = {};  // same info as in summaries above, but as a dictionary indexed by productCode
            var _referenceDate = Date.today();
            $scope.showDealerPacks = true;
            $scope.showOverRemit = true;

            $scope.init = function () {

                $scope.showDealerPacks =  authorizationService.isUrlAccessibleForUser(additionalSecuritySections.additionalMarkup);
                var loadDealerPacks = $scope.showDealerPacks;  // don't load, since we aren't going to display

                //KRE - COM 435 Change this to overRemit
                $scope.showOverRemit =  authorizationService.isUrlAccessibleForUser(additionalSecuritySections.overRemit) && authorizationService.isUIElementAccessibleForUser(productSettingsDialogConstants.overRemit);
                var loadDealerProfile = $scope.showOverRemit;

                $scope.loading = true;

                // technically, we don't really need to clear the cache here, since each "getAll..." below will clear a "column" of the cache.
                // But this is faster, and it is good to occasionally flush the entire cache.
                settingsCacheService.clearCache();
                
                var promises = [
                    profitSettingsService.getAllProfitSettings(_referenceDate),
                    dealerPreferencesService.getAllProductDisplayPreferences(_referenceDate)

                ];

                if (loadDealerPacks) {
                    promises.push(dealerPackService.getAllDealerPacks(_referenceDate));
                }

                //KRE - COM 435 Change this to getAllOverRemit
                if (loadDealerProfile) {
                    promises.push(dealerProfileService.getAllDealerProductProfile());
                }

                $q.all(promises)
                    .then(
                    function (promisedResults) {

                        // The profit settings product codes will always be a complete list of current dealer's eligible products.
                        var profitSettingProductCodes = promisedResults[0].map(function(setting) { return setting.productData.ProductCode.toUpperCase(); });
                        var dealerPreferenceProductCodes = promisedResults[1].map(function(pref) { return pref.productCode.toUpperCase();});
                        var dealerPackProductCodes = loadDealerPacks
                            ? promisedResults[2].map(function(pack) { return pack.productCode.toUpperCase(); })
                            : null;
                        //KRE - COM 435
                        var dealerProfileProductCodes = loadDealerProfile
                            ? promisedResults[3].map(function(dealerProfile) { return dealerProfile.productData.Abbreviation.toUpperCase(); })
                            : null;

                        // Create dictionary of the product codes. Each entry shows that we know we have profit setting for product code, and therefore is in the cache.
                        var isAvailableHashSet = _.object(profitSettingProductCodes.map(function(productCode) { return [productCode, { haveProfit: true }]; }));

                        // Filter out any product codes for the other settings that are not for eligible products.
                        dealerPreferenceProductCodes = dealerPreferenceProductCodes.filter(function(code) { return isAvailableHashSet[code]; });
                        if (dealerPackProductCodes) {
                            dealerPackProductCodes = dealerPackProductCodes.filter(function (code) { return isAvailableHashSet[code]; });
                        }

                        //KRE - COM 435
                        if (dealerProfileProductCodes) {
                            dealerProfileProductCodes = dealerProfileProductCodes.filter(function (code) { return isAvailableHashSet[code]; });
                        }

                        // Now update the hash set to show which of the other settings (preferences, dealer packs) are in the cache.
                        dealerPreferenceProductCodes.forEach(function(productCode) { isAvailableHashSet[productCode].havePreferences = true; });

                        if (dealerPackProductCodes) {
                            dealerPackProductCodes.forEach(function (productCode) { isAvailableHashSet[productCode].havePacks = true;  });
                        }

                        //KRE - COM 435
                        if (dealerProfileProductCodes) {
                            dealerProfileProductCodes.forEach(function (productCode) { isAvailableHashSet[productCode].haveDealerProfile = true;  });
                        }
                        // Get all unique product codes.  Essentially same as profit settings product codes, with any duplicates removed.
                        var allProductCodes = Object.keys(isAvailableHashSet);

                        // Force default preferences entry into the cache for any preferences that are missing
                        insertPreferenceDefaultsIntoCache(allProductCodes, isAvailableHashSet);

                        if (dealerPackProductCodes) {
                            // Force default packs entry into the cache for any packs that are missing
                            insertPackDefaultsIntoCache(allProductCodes, isAvailableHashSet);
                        }

                        //KRE - COM 435
                        if (dealerProfileProductCodes) {
                            // Force over remit entry into the cache for any over remits that are missing
                            insertDealerProfileDefaultsIntoCache(allProductCodes, isAvailableHashSet);
                        }

                        var displayList = allProductCodes.map(function(productCode) {
                            return {
                                productCode: productCode,
                                productTypeCode: "",   // todo: should get this from a Partner svc, or our PQT tables - currently not available
                                productName: "",
                                profitDisplay: "",      // will be changed later to a displayable string
                                preferencesDisplay: "", // ditto for for preferences
                                packsDisplay: dealerPackProductCodes && "",  // this will be null or "", changed later provided not null here
                                //KRE - COM 435 Change this to OverRemitProduct Codes
                                overRemitDisplay: dealerProfileProductCodes && ""  // this will be null or "", changed later provided not null here
                            };
                        });

                        // fill in the summaries that we want to display. All data needed should be cached at this point.
                        displayList.forEach(refreshDisplayItem);

                        _productSettingsDisplayDictionary = _.object(displayList.map(function(displayItem) { return [displayItem.productCode, displayItem]; }));
                        $scope.productSettingsDisplayList = displayList;
                        $scope.loading = false;

                    },
                    function (status, data) {
                        $scope.loading = false;
                        throw new TLCError(new Error(status + ' ' + data),AppErrorCodes.SettingsSummaryController_GeneralError);
                    });
            };

            $scope.titleCase= function(title){
                    return title.replace(
                        /\w\S*/g,
                        function(txt) {
                            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                        }
                    );
            }

            function insertPreferenceDefaultsIntoCache(productCodes, isAvailableHashSet) {
                var defaultPreferences = settingsCacheService.getCachedPreferences(dealershipModuleConstants.DEFAULT_PRODUCT, _referenceDate);

                productCodes.forEach(function(productCode) {
                    var item = isAvailableHashSet[productCode]; // guaranteed to exist

                    if (!item.havePreferences) {
                        var prefs = angular.copy(defaultPreferences);
                        prefs.productCode = productCode;
                        settingsCacheService.setCachedPreferences(productCode, _referenceDate, prefs);
                        item.havePreferences = true;
                    }
                });
            }

            function insertPackDefaultsIntoCache(productCodes, isAvailableHashSet) {
                var defaultDealerPacks = settingsCacheService.getCachedDealerPacks(dealershipModuleConstants.DEFAULT_PRODUCT, _referenceDate);

                productCodes.forEach(function(productCode) {
                    var item = isAvailableHashSet[productCode]; // guaranteed to exist

                    if (!item.havePacks) {
                        settingsCacheService.setCachedDealerPacks(productCode, _referenceDate, defaultDealerPacks);
                        item.havePacks = true;
                    }
                });
            }

            // KRE - COM 435
            function insertDealerProfileDefaultsIntoCache(productCodes, isAvailableHashSet) {
                var defaultDealerProfile = settingsCacheService.getCachedDealerProfile(dealershipModuleConstants.DEFAULT_PRODUCT, _referenceDate);

                productCodes.forEach(function(productCode) {
                    var item = isAvailableHashSet[productCode]; // guaranteed to exist
                    var dealerProfileVisible = false;
                    var dealerProfileProduct = settingsCacheService.getCachedProfitSetting(productCode, _referenceDate);
                    if (dealerProfileProduct.type.toUpperCase() != 'REGULATED'){
                        dealerProfileVisible = true;
                    }

                    if (!item.haveDealerProfile || dealerProfileVisible == false) {
                        settingsCacheService.setCachedDealerProfile(productCode, _referenceDate, defaultDealerProfile);
                        item.haveDealerProfile = false;
                    }
                });
            }

            function refreshDisplayItem(displayItem) {
                var productCode = displayItem.productCode;
                var profitSetting = settingsCacheService.getCachedProfitSetting(productCode, _referenceDate);

                displayItem.productName = profitSetting ? profitSetting.productData.ProductDescription : "";
                displayItem.productTypeCode = profitSetting ? (profitSetting.productData.ParentProductType || {}).PartnerCode || "" : "";
                displayItem.profitDisplay = profitSetting ? profitSetting.toDisplayString() : "";

                var preferences = settingsCacheService.getCachedPreferences(productCode, _referenceDate);

                parsePreferencesDisplay(preferences);
                displayItem.preferencesDisplay = preferences ? preferences.toDisplayString() : "";

                if (displayItem.packsDisplay == null) {
                    // no dealerPacks were loaded, so we are done
                    return;
                }

                var dealerPacks =  settingsCacheService.getCachedDealerPacks(productCode, _referenceDate);
                var mostRecent = mostRecentPack(dealerPacks, _referenceDate);
                displayItem.packsDisplay = mostRecent ? mostRecent.toDisplayString() : "";

                if (displayItem.overRemitDisplay == null) {
                    // no dealer Product Profile were loaded, so we are done
                    return;
                }
                //KRE - COM 4735 change this to use overRemits
                var overRemits =  settingsCacheService.getCachedDealerProfile(productCode, _referenceDate);
                var mostRecentOvrRemit = mostRecentOverRemit(overRemits, _referenceDate);
                displayItem.overRemitDisplay = mostRecentOvrRemit ? mostRecentOvrRemit.toDisplayString() : "";
                displayItem.productName = displayItem.productName == null || displayItem.productName == '' ? overRemits.productData.DisplayName : displayItem.productName;
            }

            function parsePreferencesDisplay(preferences)
            {
                if(preferences.displayProfitAndCost == 'ALWAYS')
                {
                preferences.displayProfitAndCost = 'Yes';
                }
                if(preferences.displayProfitAndCost == 'NEVER')
                {
                    preferences.displayProfitAndCost = 'No';
                }
            }

            function mostRecentPack(dealerPacks, date)  {
                if (!dealerPacks || dealerPacks.length == 0) {
                    return null;
                }
                var result = dealerPacks.reduce(function(prev, current) {
                     return (current.effectiveDate >= prev.effectiveDate && current.effectiveDate <= date) ? current : prev;
                });
                return result;
            }

            //KRE - COM 435 change this to overRemit
            function mostRecentOverRemit(overRemits, date)  {
                if (!overRemits || overRemits.length == 0) {
                    return null;
                };
                if (overRemits.length > 1) {
                    var result = overRemits.reduce(function (prev, current) {
                        return (current._createdDate >= prev._createdDate && current._createdDate <= date) ? current : prev;
                    });
                }
                return overRemits;
            }

            $scope.editSettings = function(event, productCode, initialView) {
                var displayItem = _productSettingsDisplayDictionary[productCode] || {}; // empty object is defensive, should not happen
                var productInfo = {
                    productCode: productCode,
                    productTypeCode: displayItem.productTypeCode,
                    productDisplayName:  displayItem.productName
                };
                showProductSettingsDialog(event, productInfo, initialView);
            };

            $scope.$on(dealershipModuleConstants.RERATE_PRODUCT, function(event, args){
                var productCode = args.productId;
                var displayItem = _productSettingsDisplayDictionary[productCode];
                if (displayItem) {
                    refreshDisplayItem(displayItem);
                }
            });

            // Displays product settings dialog-box.
            // Todo: this function is identical to the one in vehicle-products-controller. Refactor to share code.
            function showProductSettingsDialog(event, productInfo, initialView) {

                $mdDialog.show( {
                    controller: 'productSettingsDialogController',
                    templateUrl: 'app/modules/quote/views/product-settings-dialog.html',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    controllerAs: 'ctrl',
                    bindToController: true,
                    locals: { prod: productInfo, initialView: initialView }

                }).then(function() {
                    var productCode = productInfo.productCode;
                    var displayItem = _productSettingsDisplayDictionary[productCode];
                    if (displayItem) {
                        refreshDisplayItem(displayItem);
                    }

                }, function() {
                });

                if (event) {
                    event.stopPropagation();
                }
            };

            $scope.init();

        }
    ]);